
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Area/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["area-demo-common","area-demo-markdown","area-demo-stack"],
  getter: () => import(/* webpackChunkName: "meta__Area__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Area/index.en.md?type=demo')
};